import { OAuthStrategy } from "@clerk/types";
import LABELS from "constants/labels.json";

const authLabels = LABELS.auth;

export enum AuthMethod {
  EMAIL = "email",
  GOOGLE = "google",
  // Add more SSO providers here in the future
}

export enum SignUpStep {
  INITIAL = "initial",
  EMAIL_VERIFICATION = "email_verification",
  COMPLETING = "completing",
}

export const AUTH_ERRORS = {
  GENERAL_ERROR: authLabels.errors["general-error"],
  INVALID_EMAIL: authLabels.errors["invalid-email"],
  VERIFICATION_ERROR: authLabels.errors["verification-error"],
  SSO_ERROR: authLabels.errors["sso-error"],
} as const;

// Verification code constants
export const VERIFICATION_CODE_LENGTH = 6;

/**
 * This is a list of Clerk error codes that we want to display a long message for.
 * If a code is not in this list, we display an error message from the AUTH_ERRORS object
 * via getErrorMessage()
 *
 * Error codes are listed here: https://clerk.com/docs/errors/frontend-api
 */
export const USE_LONG_MESSAGE_FOR_ERROR_CODES: string[] = [
  // Account/Identity issues with useful longMessages
  "not_allowed_access", // "<who> <pluralization> not allowed to access this application."
  "signed_out", // "You are signed out"
  "user_locked", // "Your account is locked. For more information, please contact support."
  "user_banned", // "Your account has been banned. Please contact support."

  // Form errors
  "form_identifier_exists", // For emails: "That email address is taken. Please try another."

  // Password validation with specific feedback
  "form_password_incorrect", // "Password is incorrect. Try again, or use another method."
  "form_password_not_strong_enough", // "Given password is not strong enough."
  "form_password_no_lowercase", // "Passwords must contain at least one lowercase character."
  "form_password_no_uppercase", // "Passwords must contain at least one uppercase character."
  "form_password_no_number", // "Passwords must contain at least one number."
  "form_password_size_in_bytes_exceeded", // "Your password has exceeded the maximum number of bytes allowed..."

  // Verification code errors
  "form_code_incorrect", // "Incorrect code"

  // Authentication errors
  "authentication_invalid", // "Unable to authenticate the request, you need to supply an active session"
];

// Map AuthMethod to Clerk OAuth strategy strings
export const OAUTH_STRATEGY_MAP: Partial<Record<AuthMethod, OAuthStrategy>> = {
  [AuthMethod.GOOGLE]: "oauth_google",
  // Add more mappings here as we add providers
  // [AuthMethod.GITHUB]: "oauth_github",
  // [AuthMethod.MICROSOFT]: "oauth_microsoft",
};
